import { Container } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useUserContext } from "../../contexts/userContext";

import Navigation from "../header";
import Json from "../json";
import { Icons } from '../icons';
import ClosingStatusChart from "../closingStatusChart";
import PowerBiReportViewer from "../powerBiReportViewer";
import WaitingShipmentTable from "../tables/waitingShipmentTable";

import '../../styles/home.scss';
const Home = () => {
	const userContext = useUserContext();
	const getComponent = (component: string) => {
		switch (component) {
			case 'Favorites':
				return (
					<div>
						<section className="management-page-header">
							<div className="title">{userContext.details.firstName + "'s Favorites"}</div>
							<div className="actions"></div>
						</section>
						<div className="favorites">
							{userContext.permissions?.canManageEmployees &&
								<div>
									<NavLink to="/employee">
										<Icons.Employee height={96}></Icons.Employee>
										<p>
											Manage<br className='display-hide-mobile' /> Employees
										</p>
									</NavLink>
								</div>
							}
							{userContext.permissions?.canManageShipments &&
								<div>
									<NavLink to="/shipment">
										<Icons.Shipment height={96}></Icons.Shipment>
										<p>
											Manage<br className='display-hide-mobile' /> Shipments
										</p>
									</NavLink>
								</div>
							}
							{userContext.permissions?.canAccessTils &&
								<div>
									<NavLink to="/tils">
										<Icons.Load height={96}></Icons.Load>
										<p>
											Manage<br className='display-hide-mobile' /> Loads
										</p>
									</NavLink>
								</div>
							}
							{userContext.permissions?.canManageTrailers &&
								<div>
									<NavLink to="/trailer">
										<Icons.Trailer height={96}></Icons.Trailer>
										<p>
											Manage<br className='display-hide-mobile' /> Trailers
										</p>
									</NavLink>
								</div>
							}
						</div>
					</div>);
			case 'Closing Status':
				return (
					<div>
						{userContext.permissions?.canManageShipments &&
							<ClosingStatusChart></ClosingStatusChart>
						}
					</div>);
			case 'Waiting Shipments':
				return (
					<div>
						{userContext.permissions?.canManageShipments &&
							<WaitingShipmentTable></WaitingShipmentTable>
						}
					</div>);
			case 'Executive Dashboard':
				return (
					<>
						<section className="management-page-header">
							<div className="title">Executive Dashboard</div>
							<div className="actions"></div>
						</section>
						<div className="home-dashboard">
							<PowerBiReportViewer useRowLevelSecurity={false}  reportId='FDAC4C63-7FF8-4F95-9C62-49C7E0A610E8' type="dashboard" showNav={false} parameters={{ "filter": `DimEmployee/EmployeeID eq ${userContext.id}` }}></PowerBiReportViewer>
						</div>
					</>);
			case 'Site Manager Dashboard':
				return (
					<>
						<section className="management-page-header">
							<div className="title">Site Manager Dashboard</div>
							<div className="actions"></div>
						</section>
						<div className="home-dashboard">
							<PowerBiReportViewer useRowLevelSecurity={true} reportId='30461357-c5de-40e5-bfe5-dd357e4e31a9' type="dashboard" showNav={false} parameters={{ "filter": `DimEmployee/EmployeeID eq ${userContext.id}` }}></PowerBiReportViewer>
						</div>
					</>);
			case '':
				return (<></>);
			case '':
				return (<></>);
			case '':
				return (<></>);
			default:
				return <></>;
		}
	};

	return (
		<div className="hwi-home">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<div className="hwi-route">
					{getComponent(userContext.details.homeLayoutPosition1)}
					{getComponent(userContext.details.homeLayoutPosition2)}
					{getComponent(userContext.details.homeLayoutPosition3)}
					{getComponent(userContext.details.homeLayoutPosition4)}
					{getComponent(userContext.details.homeLayoutPosition5)}

					{/* {userContext.permissions?.canManageShipments &&
						<>
							<ClosingStatusChart></ClosingStatusChart>
							<WaitingShipmentTable></WaitingShipmentTable>
						</>
					} */}
				</div>
			</Container>
		</div>
	);
};

export default Home;